module.exports = __webpack_public_path__ + "static/media/Gilroy-Black.400f81cd.eot";